<template>
  <List>
    <template v-slot:list-header>
      <nav class="navbar navbar-light bg-light">
        <div class="container-fluid">
          <div class="navbar-brand">Playlists</div>

          <div class="nav-item">
            <div v-b-modal="'add-playlist'" class="btn btn-outline-primary">
              <b-icon-plus></b-icon-plus>
            </div>
          </div>

          <Modal id="add-playlist">
            <template v-slot:header>
              Add playlist
            </template>

            <template v-slot:content="{ changed, close }">
              <Editor v-on="{ changed, saved: created(close) }"></Editor>
            </template>
          </Modal>
        </div>
      </nav>
    </template>

    <template v-slot:list-content>
      <KeyNav :keyLevel="1" :size="playlists ? playlists.length : 0" @selected="selectAtIndex">
        <template v-slot:default="{ preselected }">
          <div class="list-group">
            <router-link v-for="(playlist, index) in playlists" :key="playlist.id" class="list-group-item" :class="[{ 'list-group-item-dark': preselected === index }]" active-class="active" :to="{ name: 'playlist.songs.index', params: { playlistId: playlist.id }}">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">{{ $date(playlist.date).format('dddd, MMMM D') }}</h5>
                <time-ago :datetime="playlist.updated_at" tag="small"></time-ago>
              </div>
            </router-link>
          </div>
        </template>
      </KeyNav>
    </template>

    <template v-slot:detail>
      <router-view></router-view>
    </template>
  </List>
</template>

<script>
  import gql from 'graphql-tag'
  
  import List from '../components/List';
  import TimeAgo from 'vue2-timeago'

  import Modal from '../components/Editor';
  import Editor from '../components/editors/Playlist';
  import KeyNav from '../components/KeyNav'

  const GET_PLAYLISTS = gql`
    query GetPlaylists {
      playlists(order_by: { created_at: desc }) {
        id
        date

        song_listings {
          song_id
          playlist_id

          song {
            id
            title
            body
          }
        }

        updated_at
      }
    }
  `

  export default {
    name: 'playlists',

    components: {
      List,
      TimeAgo,
      Modal,
      Editor,
      KeyNav
    },

    methods: {
      created(callback) {
        return function(playlist, { cache }) {
          const data = cache.readQuery({ query: GET_PLAYLISTS });
          data.playlists.splice(0, 0, playlist);

          cache.writeQuery({
            query: GET_PLAYLISTS,
            data
          })

          callback();
          this.$router.push({ name: 'playlist.songs.index', params: { playlistId: playlist.id } })
        }.bind(this)
      },

      selectAtIndex(index) {
        const playlist = this.playlists[index];
        this.$router.push({ name: 'playlist.songs.index', params: { playlistId: playlist.id } })
      }
    },
    
    apollo: {
      playlists: GET_PLAYLISTS
    }
  }
</script>

<style scoped>
  .list-group .btn:last-child {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
</style>